import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import MobileScrollFix from './components/MobileScrollFix';
import OverflowFix from './components/OverflowFix';
import Breadcrumb from './components/Breadcrumb';
import PerformanceOptimizer from './components/PerformanceOptimizer';
import MediaProtection from './components/MediaProtection';

// Lazy load pages for code splitting
const Home = lazy(() => import('./pages/Home'));
const ObraNueva = lazy(() => import('./pages/ObraNueva'));
const SobreNosotros = lazy(() => import('./pages/SobreNosotros'));
const PoliticaCookies = lazy(() => import('./pages/PoliticaCookies'));
const PoliticaPrivacidad = lazy(() => import('./pages/PoliticaPrivacidad'));
const AvisoLegal = lazy(() => import('./pages/AvisoLegal'));
const Reformas = lazy(() => import('./pages/Reformas'));
const Contact = lazy(() => import('./pages/Contact'));
const Blog = lazy(() => import('./pages/Blog'));
const Article = lazy(() => import('./pages/Article'));
const Autopromocion = lazy(() => import('./pages/Autopromocion'));
const ProyectoPoqueiras = lazy(() => import('./pages/ProyectoPoqueiras'));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <MobileScrollFix />
        <OverflowFix />
        <PerformanceOptimizer />
        <MediaProtection />
        <div className="min-h-screen bg-white">
          <Navbar />
          <div className="pt-20">
            <Breadcrumb />
            <main>
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/obra-nueva" element={<ObraNueva />} />
                  <Route path="/reformas" element={<Reformas />} />
                  <Route path="/autopromocion" element={<Autopromocion />} />
                  <Route path="/autopromocion/poqueiras" element={<ProyectoPoqueiras />} />
                  <Route path="/sobre-nosotros" element={<SobreNosotros />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<Article />} />
                  <Route path="/cookies" element={<PoliticaCookies />} />
                  <Route path="/privacidad" element={<PoliticaPrivacidad />} />
                  <Route path="/aviso-legal" element={<AvisoLegal />} />
                  <Route path="/contacto" element={<Contact />} />
                </Routes>
              </Suspense>
            </main>
          </div>
          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App; 